import WidgetUploadDocumentRequestModel from '../../../generated/types/model/request/WidgetUploadDocumentRequestModel';

export default class WidgetUploadDocumentRequestViewModel extends WidgetUploadDocumentRequestModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
